// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2770":"945ba6fb","3153":"914a7905","8510":"dea6c8eb"}[chunkId] + ".chunk.css";
};